module.exports = __webpack_public_path__ + "assets/img/txt-professionals-06.42e3c3f7.svg";